<div class="w-full p-5">
    <div class="max-w-[530px] w-full mx-auto">
        <h3 class="text-4xl font-semibold text-center">Forget Password</h3>
        <span class="block text-base text-center mt-2.5">Enter your email and get 6-digit code</span>
        <div class="w-full space-y-5 mt-8">
            <div class="">
                <input type="email" id="email" [(ngModel)]="userEmail" class="block w-full text-sm md:text-16 font-bold outline outline-1 outline-gray_3 rounded-lg py-3 md:py-3.5 lg:py-4 xl:py-5 px-5 md:px-6 lg:px-7 xl:px-8 mt-2" placeholder="Enter Email">
            </div>
            <button type="button" class="w-full text-base font-bold border border-primary bg-primary hover:bg-white text-white hover:text-primary outline-none rounded-lg anim p-4" (click)="getOTPcode()">Get OTP</button>
        </div>
    </div>
</div>